module.exports = "<div class=\"form-group radio c-radio c-radio-nofont\" [formGroup]=\"form\">\n  <label>\n    <input\n      [id]=\"input.value\"\n      [name]=\"input.key\"\n      [formControlName]=\"input.key\"\n      type=\"radio\"\n      [value]=\"input.value\"\n      (ngModelChange)=\"changeEvent($event)\"\n    ><span></span> {{ input.label }}\n  </label>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ing-dynamic-form/dynamic-form/ing-radio-button/ing-radio-button.component.html
// module id = 1307
// module chunks = 4